var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 158.416,
    height: 36
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 4",
    d: "M17.72-73.589a.545.545 0 01.456.169.545.545 0 01.169.456l-.733 5.395a.345.345 0 01-.292.3.54.54 0 01-.466-.168l-.489-.487q-.027.031-.057.06L4.533-56.088a1.388 1.388 0 01-1.963 0L.607-58.05a1.388 1.388 0 010-1.963l11.776-11.776q.03-.03.06-.057l-.313-.322a.54.54 0 01-.168-.466.345.345 0 01.3-.292z",
    transform: "translate(-.201 73.594)",
    clipRule: "evenodd",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "logo_svg__b"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 6",
    d: "M27.394-34.274l6.379-6.379a1.388 1.388 0 011.963 0l1.717 1.717a1.388 1.388 0 010 1.963l-6.379 6.379a1.388 1.388 0 01-1.963 0l-1.717-1.717a1.388 1.388 0 010-1.963z",
    transform: "translate(-26.988 41.059)",
    clipRule: "evenodd",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17505"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17296"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31539",
    d: "M18 0a18 18 0 0118 18v18H18A18 18 0 010 18 18 18 0 0118 0z",
    fill: "#5f48e9"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 17186",
    transform: "translate(6.429 6.153)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 7",
    clipPath: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 3",
    d: "M-1.736-1.572h21.22v21.22h-21.22z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 8",
    transform: "translate(9.075 10.822)",
    clipPath: "url(#logo_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 5",
    d: "M-1.735-1.735h14.341v14.341H-1.735z",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 89",
    cx: 2.545,
    cy: 2.545,
    r: 2.545,
    transform: "translate(18.15 19.652)",
    fill: "#0f0"
  })), /*#__PURE__*/React.createElement("circle", {
    "data-name": "Ellipse 1538",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(24.571 26)",
    fill: "#0f0"
  })), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31683",
    d: "M144.09 23.385a13.092 13.092 0 01-.141 1.986H131.24a4.443 4.443 0 001.53 2.729 4.667 4.667 0 003.006.94 5.389 5.389 0 002.294-.51 3.337 3.337 0 001.556-1.3l3.954 2.43a6.424 6.424 0 01-3.059 2.725 11.454 11.454 0 01-4.851.967 9.008 9.008 0 01-6.6-2.681 8.94 8.94 0 01-2.7-6.6 8.743 8.743 0 012.663-6.478 8.941 8.941 0 016.53-2.628 8.28 8.28 0 016.056 2.443 8.085 8.085 0 012.471 5.977zm-12.779-1.248h7.7a3.259 3.259 0 00-1.23-2.2 3.8 3.8 0 00-2.479-.879 4.058 4.058 0 00-2.6.809 4.059 4.059 0 00-1.391 2.27zm24.943-7.172a6.063 6.063 0 012.162.316l-.3 4.764a6.663 6.663 0 00-2.268-.4 4.012 4.012 0 00-2.1.729A4.74 4.74 0 00152 22.313V33h-5.08V15.316H152v2.092a4.583 4.583 0 011.854-1.767 5 5 0 012.4-.676z",
    fill: "#7e6afa"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 31684",
    d: "M45.916 7.793h5.326v20.092h11.549V33H45.916zm36.053 15.592a13.092 13.092 0 01-.141 1.986H69.119a4.443 4.443 0 001.529 2.729 4.667 4.667 0 003.006.94 5.389 5.389 0 002.294-.51 3.337 3.337 0 001.556-1.3l3.955 2.43a6.424 6.424 0 01-3.059 2.725 11.454 11.454 0 01-4.852.967 9.008 9.008 0 01-6.6-2.681 8.94 8.94 0 01-2.7-6.6 8.743 8.743 0 012.663-6.478 8.941 8.941 0 016.53-2.628 8.28 8.28 0 016.059 2.443 8.085 8.085 0 012.469 5.977zm-12.78-1.248h7.7a3.259 3.259 0 00-1.23-2.2 3.8 3.8 0 00-2.479-.879 4.058 4.058 0 00-2.6.809 4.059 4.059 0 00-1.391 2.27zm28.143-6.82h5.08V33h-5.08v-2.092a4.62 4.62 0 01-2.1 1.767 7.287 7.287 0 01-3.12.677 7.5 7.5 0 01-4.166-1.23 8.58 8.58 0 01-2.988-3.349 9.974 9.974 0 01-1.09-4.632 9.387 9.387 0 012.4-6.5 7.565 7.565 0 015.845-2.672 7.226 7.226 0 013.111.686 4.708 4.708 0 012.109 1.758zm-4.1 13.219a4.892 4.892 0 002.4-.615 4.393 4.393 0 001.7-1.582v-4.324a4.427 4.427 0 00-1.7-1.635 4.786 4.786 0 00-2.4-.633A4.266 4.266 0 0090.107 21a4.242 4.242 0 00-1.266 3.138 4.242 4.242 0 001.266 3.138 4.266 4.266 0 003.129 1.259zm25.44-20.743h5.08V33h-5.08v-2.092a4.62 4.62 0 01-2.1 1.767 7.287 7.287 0 01-3.12.677 7.5 7.5 0 01-4.166-1.23 8.58 8.58 0 01-2.986-3.35 9.974 9.974 0 01-1.09-4.632 9.387 9.387 0 012.4-6.5 7.565 7.565 0 015.845-2.672 7.226 7.226 0 013.111.686 4.708 4.708 0 012.109 1.758zm-4.1 20.742a4.892 4.892 0 002.4-.615 4.393 4.393 0 001.7-1.582v-4.324a4.427 4.427 0 00-1.7-1.635 4.786 4.786 0 00-2.4-.633A4.266 4.266 0 00111.447 21a4.242 4.242 0 00-1.266 3.138 4.242 4.242 0 001.266 3.138 4.266 4.266 0 003.129 1.259z",
    fill: "#fff"
  }))));
}

export default SvgLogo;